import React, { useContext, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { Breadcrumb, Image, Toast } from "react-bootstrap";
import { get, find, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { InnerLayoutButtons } from "../";
import {
  setManageEligibilityFlow,
  setManageEligibilityToastInfo,
  getEligibilityDetailsAction,
  manageFeeStore,
  setManageFeeToastInfo,
} from "../../contexts";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import {
  ROUTES,
  manageEligibilityFormNames,
  apiErrors,
  getPathWithParam,
  ALL_MANAGE_FEE_ROUTES,
} from "../../utils";
import { useFormikContext } from "formik";
import Cancel from "../../styles/cancel.png";
import RouteLeavingGuard from "../RouteLeavingGuard";

const ManageFeeLayout = ({
  children,
  isCreateFee = false,
  buttons = [],
  tabs,
  pageFlow,
  layoutHeader,
  customBreadCrumbs,
  history,
  className,
}) => {
  const [showError, setShowError] = useState(false);
  const { state, dispatch } = useContext(manageFeeStore);
  const eligibilityName = get(
    state,
    `${manageEligibilityFormNames.ELIGIBILITY_PROCESS}.eligibilityName`
  );
  const { eligibilityId, flow } = useRouterParams();
  const { showToast, toastMessage } = state;
  const {
    isSubmitting,
    dirty,
    resetForm,
    setSubmitting,
  } = useFormikContext() || { dirty: false };

  const apiError = get(state, "api.error", {});
  const apiData = get(state, "api.data", {});
  const menuDetails = find(ALL_MANAGE_FEE_ROUTES, (item) => {
    if (get(state, "selectedMenu", "").indexOf(get(item, "path")) !== -1) {
      return true;
    }
    return false;
  });

  useDeepEffect(() => {
    if (isEmpty(apiData) && eligibilityId) {
      dispatch(getEligibilityDetailsAction(eligibilityId, dispatch, state));
      dispatch(setManageEligibilityFlow({ flow, eligibilityId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eligibilityId]);
  const breadCrumOptions = [
    // {
    //   label: "Home",
    //   link: ROUTES.HOME,
    // },
    // {
    //   label: "Eligibility",
    //   link: ROUTES.MANAGE_ELIGIBILITY,
    // },
  ];
  useDeepEffect(
    () => {
      if (!isEmpty(apiError)) {
        setShowError(true);
      }
    },
    [apiError],
    true
  );

  const breadCrumbsFromMenuDetails = get(menuDetails, "breadCrumbs", []);
  if (!isEmpty(customBreadCrumbs)) {
    breadCrumOptions.push(...customBreadCrumbs);
  } else if (!isEmpty(breadCrumbsFromMenuDetails)) {
    breadCrumOptions.push(
      ...breadCrumbsFromMenuDetails.map((item) => ({
        ...item,
        link: getPathWithParam({
          path: item.link,
          pathParam: [flow, eligibilityId],
        }),
      }))
    );
  }

  const onRefresh = () => {
    if (resetForm) {
      resetForm();
      setSubmitting(false);
    }
  };

  const errorStatus = get(apiError, "response.status", 500);
  const errorData = apiErrors[errorStatus];

  return (
    <div className={`d-flex flex-column manage-company h-100 ${className}`}>
      <div className="d-flex flex-column layout-header">
        <div className="d-flex align-items-center">
          <div>
            <Breadcrumb>
              {breadCrumOptions.slice(-4).map((item, index) => (
                <Breadcrumb.Item key={index}>
                  <Link to={item.link}>{item.label}</Link>
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
            <div className="d-flex">
              {isCreateFee && (
                <h5
                  className="grey-text mr-2"
                  style={{
                    fontSize: "1rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Step {get(menuDetails, "step", "")}:
                </h5>
              )}
              <h5>{layoutHeader || get(menuDetails, "contentHeader", "")}</h5>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center tab-wrapper">
            {tabs}
          </div>
          <div className="ml-auto">
            <InnerLayoutButtons
              menu="eligibility"
              subMenu={get(menuDetails, "id", "")}
              buttonsList={buttons}
              flow={pageFlow}
            />
          </div>
          {showError && (
            <div
              className={`error-banner justify-content-between d-flex align-items-center ${
                (showError && "enable") || ""
              }`}
            >
              <div>
                <Image src={Cancel} width="30px" />
              </div>
              <div>
                <div className="error-heading">{errorData.heading}</div>
                <div className="error-reason">{errorData.reason}</div>
              </div>
              <div>
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  color="#000"
                  style={{ fontSize: "14px" }}
                  onClick={() => setShowError(false)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="layout-content h-100 overflow-auto">{children}</div>
      <Toast
        onClose={() =>
          dispatch(
            setManageFeeToastInfo({
              showToast: false,
              toastMessage: "",
            })
          )
        }
        show={showToast}
        style={{
          position: "fixed",
          top: "7rem",
          right: "1rem",
          zIndex: "100",
        }}
        delay={3000}
        autohide
      >
        <Toast.Body className="success-toast-align">
          <div className="mr-2">
            {showToast ? (
              <FontAwesomeIcon icon={faCheckCircle} color="#3BB54A" size="lg" />
            ) : (
              ""
            )}
          </div>
          <div>{toastMessage}</div>
          <div className="ml-2">
            {showToast ? (
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000000"
                size="md"
                onClick={() =>
                  dispatch(
                    setManageEligibilityToastInfo({
                      showToast: false,
                      toastMessage: "",
                    })
                  )
                }
              />
            ) : (
              ""
            )}
          </div>
        </Toast.Body>
      </Toast>
      <RouteLeavingGuard
        when={!isSubmitting && dirty}
        navigate={(path) => history.push(path)}
        onRefresh={onRefresh}
      />
    </div>
  );
};

export default withRouter(ManageFeeLayout);
